// extracted by mini-css-extract-plugin
module.exports = {"social":"styles_social__1r8xt"};